import { NgModule }      from '@angular/core';
import { PubNubEngine }   from '../pubnub.engine.service';
import { PubNubAngular } from 'pubnub-angular2';
import { PubNubNotifier } from '../pubnub.notification.service';


@NgModule({
  imports:      [ ],
  declarations: [ ],
  providers: [ 
    PubNubAngular,
    PubNubEngine,
    PubNubNotifier 
  ],
  exports:      [ ],
})

export class NotificationApiModule {
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/notification/module/notification.api.module.ts